"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgIcon_1 = require("@material-ui/core/SvgIcon");
exports.default = (displayName, svgNode) => {
    const Component = React.memo(React.forwardRef((props, ref) => (React.createElement(SvgIcon_1.default, Object.assign({ "data-brikl-ui-test": `${displayName}Icon`, ref: ref }, props), svgNode))));
    Component.displayName = displayName;
    // TODO: Fix types conflicts on this export
    // @ts-ignore
    return Component;
};
//# sourceMappingURL=createIconComponent.js.map